import { useMemo } from 'react'

import { ROOMS } from '@/shared/types/rooms'
import { HotelReservation } from '@monorepo/functions/src/types/reservations'

export const useAvailableRooms = (reservations: HotelReservation[]) => {
    const currentPetsInRooms = useMemo(() => {
        const petsInRooms: { [key: string]: Array<{ name: string; breed: string; sex: string }> } = ROOMS.reduce(
            (acc, room) => {
                acc[room] = []
                return acc
            },
            {} as { [key: string]: Array<{ name: string; breed: string; sex: string }> },
        )

        reservations.forEach(reservation => {
            reservation.pets.forEach(pet => {
                if (pet.roomNumber) {
                    petsInRooms[pet.roomNumber].push({
                        name: pet.name,
                        breed: pet.breed,
                        sex: pet.sex,
                    })
                }
            })
        })
        return petsInRooms
    }, [reservations])

    return { currentPetsInRooms, availableRooms: ROOMS }
}
